var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('a',{staticClass:"logo-link",attrs:{"href":"https://dh.gu.se/"}},[_c('CdhLogo')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }